/**
 * Helper function used to add '!important' to style rule (using this allows better IDE
 * interaction with CSS (i.e. #rgb colors are detected and allows launch of color picker)
 */
export default function important(style: string | number) {
  return style + ' !important'
}
